import { WHATSAPP_LINK_ECOMMERCE } from 'domains/new-plan/constants/whatsapp';
import React from 'react';
import './contact-button.scss';

interface IContactButtonProps {
  link?: string;
}
export const ContactButton: React.FC<IContactButtonProps> = (
  props: IContactButtonProps,
) => {
  const { link } = props;
  return (
    <div className="contact-button">
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        role="button"
        aria-label="Botón de WhatsApp"
      >
        <div className="contact-button__image"></div>
      </a>
    </div>
  );
};

ContactButton.defaultProps = {
  link: WHATSAPP_LINK_ECOMMERCE,
};
